import state from '../store';

// 获取环境
export var getEnv = function getEnv() {
  try {
    var _state$feConfig, _state$feConfig$commo, _state$feConfig2;
    var apiEnv = state == null ? void 0 : (_state$feConfig = state.feConfig) == null ? void 0 : (_state$feConfig$commo = _state$feConfig.common) == null ? void 0 : _state$feConfig$commo.environment;
    var env = state == null ? void 0 : (_state$feConfig2 = state.feConfig) == null ? void 0 : _state$feConfig2.apiEnv; // 只有奇点项目特殊处理
    if (!apiEnv) {
      return 'green'; // node 走产线
    }

    if (apiEnv === 'dev') {
      // d，t环境
      return env === 'di-singular' ? 'di-singular' : apiEnv;
    } else if (apiEnv === 'stable') {
      return env === 'tf-singular' ? 'tf-singular' : apiEnv;
    } else {
      var _state$feConfig3;
      var isSGP = (state == null ? void 0 : (_state$feConfig3 = state.feConfig) == null ? void 0 : _state$feConfig3.apiEnv) === 'bfsgprod'; // 新加坡集群
      return isSGP ? 'bfsgprod' : (state == null ? void 0 : state.YXT_SWL_COLOR) || 'green';
    }
  } catch (error) {
    // 埋点
    // fecentrLog('获取环境失败',{error})
    return 'green';
  }
};

// fecenter上报错误
export var fecentrLog = function fecentrLog(message, option) {
  if (option === void 0) {
    option = {};
  }
  try {
    var _window, _window$yxtRPT, _window2, _window2$yxtRPT, _option, _option2;
    state.isBrowser && ((_window = window) == null ? void 0 : (_window$yxtRPT = _window.yxtRPT) == null ? void 0 : _window$yxtRPT.report) && ((_window2 = window) == null ? void 0 : (_window2$yxtRPT = _window2.yxtRPT) == null ? void 0 : _window2$yxtRPT.report({
      category: 302,
      msg: message,
      w_succ: (_option = option) == null ? void 0 : _option.w_succ,
      c1: JSON.stringify({
        error: (_option2 = option) == null ? void 0 : _option2.error
      })
    }));
  } catch (error) {
    console.error(error);
  }
};

// 是否是移动端
export var isMobileClient = function isMobileClient() {
  return !!window.navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i); // 是否手机端
};